import { Component, ViewChild } from "@angular/core";
import { DxDataGridComponent } from "devextreme-angular";
import { exportDataGrid } from "devextreme/excel_exporter";
import { Workbook } from "exceljs";
import saveAs from 'file-saver';
import { NotificationService } from "src/app/common/component/notification/notification.service";
import { O2PortalASUReferenceListService } from "./o2-portal-asu-reference-list.service";

@Component({
    selector: 'O2PortalASUReferenceList',
    templateUrl: './o2-portal-asu-reference-list.component.html',
    styleUrls: ['./o2-portal-asu-reference-list.component.scss']
})

export class O2PortalASUReferenceListComponent {

    isLoadPanelVisible: boolean = false;
    o2PortalASUReferenceListData: any;
    readonly allowedPageSizes = [50, 100, 200];
    @ViewChild(DxDataGridComponent, { static: false }) dataGrid: DxDataGridComponent;

    constructor(private notificationService: NotificationService, private o2PortalASUReferenceListService: O2PortalASUReferenceListService) {
        this.getO2PortalASUReferenceList();
    }

    getO2PortalASUReferenceList() {
        this.isLoadPanelVisible = true;
        this.o2PortalASUReferenceListService.getO2PortalASUReferenceList().subscribe({
            next: o2PortalASUReferenceListData => {
                this.o2PortalASUReferenceListData = o2PortalASUReferenceListData;
                this.isLoadPanelVisible = false;
            }, error: (error: any) => {
                this.isLoadPanelVisible = false;
                this.notificationService.alert("error", "Error while fetching O2PortalASUReferenceList data", error);
            }
        });
    }

    resetFilters() {
        this.dataGrid.instance.clearFilter();
        this.dataGrid.instance.clearSorting();
    }

    exportExcel(e) {
        this.dataGrid.instance.columnOption('siteId', 'visible', true);
        const workbook = new Workbook();
        const worksheet = workbook.addWorksheet('Main sheet');
        exportDataGrid({
            component: this.dataGrid.instance,
            worksheet: worksheet
        }).then(function () {
            workbook.xlsx.writeBuffer()
                .then(function (buffer: BlobPart) {
                    saveAs(new Blob([buffer], { type: 'application/octet-stream' }), 'ASUReferenceList.xlsx');
                });
        }).then(() => {
            this.dataGrid.instance.columnOption('siteId', 'visible', false);
        });
        e.cancel = true;
    }
}